export default {
  aufHeroLabel: 'A stay at the Alpenhof',
  aufHeroTitle: 'More than a bed.\nA feel-good\nexperience.',
  aufHeroText: 'From a lovingly prepared breakfast to a quiet hour in the garden – we make your stay more than just a night’s sleep.',

  aufBreakfastTitle: 'A breakfast that shapes the day',
  aufBreakfastText: 'Fresh, regional produce, beautifully arranged – our breakfast is a culinary prelude to the day ahead.',
  aufCard1Title: 'Organic & regional',
  aufCard1Text: 'Organic products from the Andechs dairy, bread from Europe’s best organic baker and many more carefully chosen ingredients.',
  aufCard2Title: 'Choice & variety',
  aufCard2Text: 'From classic muesli to a warm breakfast egg – you choose how the day begins.',
  aufCard3Title: 'Personal service',
  aufCard3Text: 'Special requests? Gluten-free? Vegan? We are happy to meet your needs.',

  aufStayTitle: 'What makes your stay special',
  aufStayText: 'Small details with a big effect – so you feel completely at ease.',
  aufHighlight1Title: 'Garden & nature',
  aufHighlight1Text: 'In summer, our garden invites you to linger – a green retreat in the heart of the Würmtal valley.',
  aufHighlight2Title: 'Cosiness',
  aufHighlight2Text: 'Tile-stove parlour, library and seating nooks – there is a favourite spot for everyone.',
  aufHighlight3Title: 'Personal care',
  aufHighlight3Text: 'We know our guests – and we are delighted when you return. Small, familial, attentive.',
  aufHighlight4Title: 'Prime location',
  aufHighlight4Text: 'Between Munich, Lake Starnberg and the Alps – the perfect base for many days in Bavaria.',

  aufInfoTitle: 'Useful information',
  aufInfoSubtitle: 'So you don’t have to worry about a thing.',
  aufInfo1Title: 'Check-in & check-out',
  aufInfo1In: 'from 3:00 pm',
  aufInfo1Out: 'until 12:00 noon',
  aufInfo1Note: 'Earlier or later times available on request.',
  aufInfo2Title: 'Breakfast hours',
  aufInfo2Weekday: '7:00 – 10:00 am',
  aufInfo2Weekend: '8:00 – 11:00 am',
  aufInfo2Note: 'Weekend hours apply on public holidays too.',
  aufInfo3Title: 'Parking',
  aufInfo3Text: 'Free parking right at the hotel.',
  aufInfo3Note: 'No reservation required.',
  aufInfo4Title: 'Wi-Fi',
  aufInfo4Text: 'Complimentary Wi-Fi throughout the building.',
  aufInfo4Note: 'Access details available at reception.',

  aufGalleryTitle: 'A look inside',
  aufGalleryText: 'A few impressions that say more than any description.',

  aufCtaLabel: 'Ready to book?',
  aufCtaTitle: 'Your stay starts with an enquiry.',
  aufCtaText: 'Check availability and secure your favourite date – we look forward to welcoming you.',
  aufCtaButton: 'Check availability',
};
